// extracted by mini-css-extract-plugin
module.exports = {"fullHeightContainer":"HomePageSeedComponent_fullHeightContainer__3sjtv","flexRow":"HomePageSeedComponent_flexRow__2WcWS","staticRow":"HomePageSeedComponent_staticRow__2NqSb"};